





























































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePengantarKulturAntibiotika } from "@/store/modules/PengantarKulturAntibiotikaStore";
import PengantarKulturAntibiotikaSvc from "@/services/PengantarKulturAntibiotika";

interface AbxRow {
  nama: string;
  tgl_awal_pemberian: string;
  dosis: string;
  rute: string;
}

interface AlatRow {
  nama: string;
  label: string;
  digunakan: boolean;
  tgl_mulai: string;
  keterangan?: string;
}

function makeAlatDefault(): AlatRow[] {
  return [
    { nama: "kateter_arterial", label: "Kateter Arterial", digunakan: false, tgl_mulai: "" },
    { nama: "kateter_vena", label: "Kateter Vena Central / Perifer", digunakan: false, tgl_mulai: "" },
    { nama: "kateter_uretra", label: "Kateter Uretra", digunakan: false, tgl_mulai: "" },
    { nama: "ett", label: "ETT", digunakan: false, tgl_mulai: "" },
    { nama: "ngt", label: "NGT", digunakan: false, tgl_mulai: "" },
    { nama: "lain", label: "Lain-lain", digunakan: false, tgl_mulai: "", keterangan: "" }
  ];
}

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PengantarKulturAntibiotikaInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  requiredRule = [v => !!v || "*Kolom ini harus diisi"];

  jenisSpesimenOpts = [
    { value: "darah", label: "Darah (2 botol)" },
    { value: "pus", label: "Pus" },
    { value: "urin", label: "Urin" },
    { value: "sputum", label: "Sputum" },
    { value: "feses", label: "Feses" },
    { value: "lain", label: "Lain-lain" }
  ];

  ruteOpts = [
    { value: "topikal", text: "Topikal" },
    { value: "oral", text: "Oral" },
    { value: "im", text: "IM" },
    { value: "iv", text: "IV" }
  ];

  form_data = this.defaultForm();

  defaultForm() {
    const today = localISODate();
    return {
      tgl_permintaan: today,
      ruang_poli: "",
      tgl_masuk_rs: "",
      diagnosis: "",
      dokter_pengirim_id: null as number | null,
      jenis_spesimen: [] as string[],
      spesimen_lain_keterangan: "",
      jam_pengambilan_spesimen: "",
      suhu_pasien: null as number | null,
      deskripsi_ketepatan_sampling: "",
      antibiotik_digunakan: [
        { nama: "", tgl_awal_pemberian: "", dosis: "", rute: "" },
        { nama: "", tgl_awal_pemberian: "", dosis: "", rute: "" },
        { nama: "", tgl_awal_pemberian: "", dosis: "", rute: "" }
      ] as AbxRow[],
      alat_invasif: makeAlatDefault(),
      keterangan_antibiotik: "",
      minta_kultur_aerob: false,
      minta_uji_kepekaan: false,
      minta_khusus: ""
    };
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get storeUser() {
    return userModule.user;
  }

  get isLainSelected() {
    return (this.form_data.jenis_spesimen || []).includes("lain");
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editData) {
        this.hydrateFromEdit();
      } else {
        this.form_data = this.defaultForm();
        if (this.storeUser?.profesi === "Dokter") {
          this.form_data.dokter_pengirim_id = this.storeUser.id;
        }
      }
    }
  }

  hydrateFromEdit() {
    const d = this.editData || {};
    const alat = makeAlatDefault();
    const alatSaved = (d.alat_invasif || []) as any[];
    alat.forEach(row => {
      const saved = alatSaved.find(a => a.nama === row.nama);
      if (saved) {
        row.digunakan = !!saved.digunakan;
        row.tgl_mulai = saved.tgl_mulai || "";
        if (row.nama === "lain") row.keterangan = saved.keterangan || "";
      }
    });

    const abxSaved = (d.antibiotik_digunakan || []) as AbxRow[];
    const abx: AbxRow[] = [0, 1, 2].map(i => ({
      nama: abxSaved[i]?.nama || "",
      tgl_awal_pemberian: abxSaved[i]?.tgl_awal_pemberian || "",
      dosis: abxSaved[i]?.dosis || "",
      rute: abxSaved[i]?.rute || ""
    }));

    this.form_data = {
      tgl_permintaan: d.tgl_permintaan || localISODate(),
      ruang_poli: d.ruang_poli || "",
      tgl_masuk_rs: d.tgl_masuk_rs || "",
      diagnosis: d.diagnosis || "",
      dokter_pengirim_id: d.dokter_pengirim?.id || null,
      jenis_spesimen: Array.isArray(d.jenis_spesimen) ? d.jenis_spesimen : [],
      spesimen_lain_keterangan: d.spesimen_lain_keterangan || "",
      jam_pengambilan_spesimen: d.jam_pengambilan_spesimen
        ? String(d.jam_pengambilan_spesimen).substr(0, 16)
        : "",
      suhu_pasien: d.suhu_pasien || null,
      deskripsi_ketepatan_sampling: d.deskripsi_ketepatan_sampling || "",
      antibiotik_digunakan: abx,
      alat_invasif: alat,
      keterangan_antibiotik: d.keterangan_antibiotik || "",
      minta_kultur_aerob: !!d.minta_kultur_aerob,
      minta_uji_kepekaan: !!d.minta_uji_kepekaan,
      minta_khusus: d.minta_khusus || ""
    };
  }

  buildPayload() {
    const abx = (this.form_data.antibiotik_digunakan || []).filter(
      a => a.nama || a.dosis || a.tgl_awal_pemberian || a.rute
    );
    const alat = (this.form_data.alat_invasif || []).map(a => ({
      nama: a.nama,
      digunakan: !!a.digunakan,
      tgl_mulai: a.digunakan ? a.tgl_mulai || null : null,
      keterangan: a.nama === "lain" ? a.keterangan || null : null
    }));

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tgl_permintaan: this.form_data.tgl_permintaan || null,
      ruang_poli: this.form_data.ruang_poli || null,
      tgl_masuk_rs: this.form_data.tgl_masuk_rs || null,
      diagnosis: this.form_data.diagnosis || null,
      dokter_pengirim_id: this.form_data.dokter_pengirim_id,
      jenis_spesimen: this.form_data.jenis_spesimen,
      spesimen_lain_keterangan: this.form_data.spesimen_lain_keterangan || null,
      jam_pengambilan_spesimen: this.form_data.jam_pengambilan_spesimen || null,
      suhu_pasien: this.form_data.suhu_pasien ?? null,
      deskripsi_ketepatan_sampling: this.form_data.deskripsi_ketepatan_sampling || null,
      antibiotik_digunakan: abx,
      keterangan_antibiotik: this.form_data.keterangan_antibiotik || null,
      alat_invasif: alat,
      minta_kultur_aerob: !!this.form_data.minta_kultur_aerob,
      minta_uji_kepekaan: !!this.form_data.minta_uji_kepekaan,
      minta_khusus: this.form_data.minta_khusus || null
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;

    if (!this.form_data.jenis_spesimen.length) {
      (this.$root as any).$emit?.("notify", "Pilih minimal 1 jenis spesimen");
      alert("Pilih minimal 1 jenis spesimen");
      return;
    }

    if (this.saving) return;
    this.saving = true;

    try {
      const payload = this.buildPayload();
      const resp = this.editData
        ? await PengantarKulturAntibiotikaSvc.update(this.editData.id, payload)
        : await PengantarKulturAntibiotikaSvc.create(payload);

      if (resp.data.status == "1") {
        await storePengantarKulturAntibiotika.getByRegister(this.register);
        this.dialog = false;
        this.$emit("saved");
      }
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
